module.exports = __webpack_public_path__ + "img/belgium-infectious-diseases-female.5db6fc14.png";